<template>
  <div>
    <!-- 头部 -->
    <Menu :actived="0" />
    <!-- 头部 -->

    <!-- 轮播图 -->
    <Carousel 
        v-if="bannerList.length > 0" 
        :bannerList="bannerList" 
        :mode="bannerMode"></Carousel>
    <!-- 轮播图 -->

    <div class="template7_inner_container">
      
      
      <!-- 简介 -->
      <div class="template7_description_wrap">
        <router-link class="studioDesc" to="/about">
          <div class="description_wrap">
            <div class="avatar_url">
              <img :src="logoUrl" class="img-fluid" alt="">
            </div>
            <div class="header_des">
              <div class="title">{{studioName}}</div>
              <div class="sub_title">About Us</div>
              <div class="description_content">
                <p>
                  {{studioDesc}}
                </p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <!-- 简介 -->
      
      <!-- 视频 -->
      <div class="template7_index_waterfall_wrap template8_video_index_container" style="max-width:1200px;"
        v-if="video">
        <div class="des_header">
          <p class="title"><span>VIDEO</span></p>
          <p class="sub_title">视频展示</p>
        </div>
      
      
        <div class="video_wrap" style="overflow:hidden;background:#000;margin-top:3em;">
          <div class="video_is_pfop" style="height:600px">
            <video :src="video" style="width:100%;height:600px;" controls controlsList="nodownload" autoplay loop muted playsinline></video>
          </div>
        </div>
      </div>
      <!-- 视频 -->

      <!-- 案例 -->
      <div class="template7_index_waterfall_wrap">
        
        <div class="des_header">
          <p class="title"><span>作品欣赏</span></p>
          <p class="sub_title">Our Works</p>
        </div>



        <div class="work_list_wrap fadeIn animation2" style="margin-top:3em;">
          <div class="work_list_content" style="transform: translateX(0)">

            <div class="work_item_wrap7"
            v-for="(item,index) in workList"
            v-bind:key = "item.worksId"
            >

              <div class="work_item" v-if="index < 8 && item.worksCover != ''">
                <a>
                  <div style="width: 100%; overflow: hidden">
                      <div class="cover_url_item" style="height:456px;">
                        <router-link target="_blank" class="router" :to="{ path: '/workInfo', query: { id: item.worksId }}">
                          <img :src="item.worksCover[0][0] +'/applet_suo'" class="img-fluid" alt=""/>
                        </router-link>
                      </div>
                  </div>
                  <div class="title ellipsis" style="padding:10px;text-align:center;">
                    {{ item.worksName }}
                  </div>
                </a>
              </div>

            </div>

            
          </div>
        </div>

        <router-link class="more_btn2" style="margin:40px auto;" to="/workList">MORE</router-link>
      </div>
      <!-- 案例 -->


      

      

      <!-- 服务套餐 -->
      <div class="template7_index_waterfall_wrap" v-if="goodShow">
        

        <div class="des_header">
          <p class="title"><span>服务套餐</span></p>
          <p class="sub_title">Service exhibition</p>
        </div>

        <div class="work_list_wrap fadeIn animation2" style="margin-top:3em;">
          <div class="work_list_content" style="transform: translateX(0)">

            <div class="work_item_wrap"
            v-for="item in goodList"
            v-bind:key = "item.id"
            >

            
              <div class="work_item" v-if="item.img != ''">
                <a>
                  <div style="width: 100%; overflow: hidden">
                      <div class="cover_url_item">
                        <router-link target="_blank" class="router" :to="{ path:'/goodInfo',query: {id: item.id}}">
                          <img :src="item.img[0][0] + '/applet_suo'" class="img-fluid" alt=""/>
                        </router-link>
                      </div>
                  </div>
                  <div class="title ellipsis">
                    {{item.name}}
                  </div>
                  <div class="sub_title">{{item.price}}</div>
                </a>
              </div>

            </div>

            
          </div>
        </div>

        <router-link class="more_btn2" style="margin:40px auto;" to="/goodList">MORE</router-link>
      </div>
      <!-- 服务套餐 -->

      <!-- 案例 -->
      <div class="template7_index_waterfall_wrap">
      
        <div class="des_header">
          <p class="title"><span>客片动态</span></p>
          <p class="sub_title">New Arrivals</p>
        </div>
      
      
      
        <div class="work_list_wrap fadeIn animation2" style="margin-top:3em;">
          <div class="work_list_content"  style="transform: translateX(0);flex-wrap: wrap;">
      
            <div class="work_item_wrap7" style="width:33.333%;padding:0 8px;" v-for="(item,index) in caseList" v-bind:key="item.worksId">
      
      
              <div class="work_item" v-if="index < 6 && item.worksCover != ''">
                <a>
                  <div style="width: 100%; overflow: hidden">
                    <div class="cover_url_item" style="height:600px;">
                      <router-link target="_blank" class="router" :to="{ path: '/caseInfo', query: { id: item.worksId }}">
                        <img :src="item.worksCover[0][0] +'/applet_suo'" class="img-fluid" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="title ellipsis" style="padding:10px;text-align:center;">
                    {{ item.worksName }}
                  </div>
                </a>
              </div>
      
            </div>
      
      
          </div>
        </div>
      
        <router-link class="more_btn2"  style="margin:40px auto;" to="/caselist">MORE</router-link>
      </div>
      <!-- 案例 -->

      

      <!-- 底部 -->
      <Footer
      :studioName="this.studioName"
      :weixin="this.weixin"
      :phone="phone"
      :studioAddress="this.studioAddress"
      :addressList="studioAddressList"
      :banner="footBg"
      :wxQrcode="wxcode"
      />
      <!-- 底部 -->

    </div>
  </div>
</template>
<script>
import axios from "axios";
import "../../public/styles/template7.css"
import "../../public/styles/home.css"
import Footer from "../components/common/Footer"
import Carousel from "../components/common/Carousel"
import Menu from "../components/common/Menu"

export default {
  name:"Home",
  data() {
    return {
      logoUrl:'',
      bannerList:[],
      studioName:'',
      studioDesc:'',
      studioAddress:'',
      studioAddressList:[],
      workList:[],
      goodList:[],
      caseList:[],
      video:'',
      weixin:'',
      phone: '',
      work0:[],
      work1:[],
      work2:[],
      work3:[],
      work4:[],
      work5:[],
      work6:[],
      work7:[],
      work8:[],
      work9:[],
      work10:[],
      codeShow:0,
      typeList:[],
      footBg:'',
      wxcode:'',
      bannerMode:0,
      goodShow:''
    };
  },
  components:{
    Footer,
    Carousel,
    Menu
  },
  mounted: function () {
    this.getStudioInfo()
    this.goodShow = this.$store.state.info.menu[2][0]
  },
  methods: {
    getStudioInfo(){
      let self = this
      const domain = document.domain;
      // const domain = 'txty.hunyuehui.com';
      const url = "https://api.marryandjoy.com:8443/getstudiobydomain?id=" + domain
      axios.get(url).then(
        function(response) {
          self.logoUrl = response.data.data.logo[0]
          self.bannerList = response.data.data.banner
          self.footBg = 'https://static.picbling.cn/img/temp_bg.jpg'
          self.studioName = response.data.data.name
          self.studioDesc = response.data.data.desc
          self.studioAddress = response.data.data.address
          self.studioAddressList = response.data.data.addressList
          self.weixin = response.data.data.weixin
          self.phone = response.data.data.phone
          self.studioId = response.data.data.sid
          self.video = response.data.data.video
          self.wxcode = response.data.data.wxQrcode
          self.bannerMode = Number(response.data.data.bannerType)

          self.getTypeList(self.studioId)
          self.getWorkList(self.studioId)
          self.getGoodList(self.studioId)
          self.getCaseList(self.studioId)
        },
        function(res) {
          console.log(res.data);
        }
      )
    },

    getWorkList(sid){
      let self = this
      const workurl = "https://api.marryandjoy.com:8443/getappletworks?"+"sid="+sid+'&show=1&perPage=12&page=1'
      axios.get(workurl).then(
        function(response) {
          self.workList = response.data.data
        },
        function(res) {
          console.log(res.data);
        }
      );
    },

    getGoodList(sid){
      let self = this
      const goodurl = "https://api.marryandjoy.com:8443/getgoodslistapplet?"+"sid="+sid+'&status=1&perPage=10&page=1'
      axios.get(goodurl).then(
        function(response) {
          self.goodList = response.data.data
        },
        function(res) {
          console.log(res.data);
        }
      );
    },
    getCaseList (sid) {
      let self = this
      const workurl = "https://api.marryandjoy.com:8443/getappletcaselist?" + "sid=" + sid + '&show=1&perPage=12&page=1'
      axios.get(workurl).then(
        function (response) {
          self.caseList = response.data.data
        },
        function (res) {
          console.log(res.data);
        }
      );
    },

    showCode(){
      this.codeShow=1
    },
    hideCode(){
      this.codeShow=0
    },
    getTypeList(sid){
      let self = this
      const goodurl = "https://api.marryandjoy.com:8443/getappletclass?"+"sid="+sid+'&type=1&pageSize=3&pageNo=1'
      axios.get(goodurl).then(
        function(response) {
          console.log(response);
          self.typeList = response.data.data.list
        },
        function(res) {
          console.log(res.data);
        }
      );
    }


  }
};
</script>
<style>
#carousel-fade{
  width: 100%;
  height: 46.875vw;
  position: fixed;
  overflow: hidden;
  margin-top: 70px;
}
.nav-a{
  text-decoration: none;
}
.studioDesc{
  text-decoration: none;
}
.more_btn{
  text-decoration: none;
}
.more_btn2{
    width: 218px;
    height: 44px;
    line-height: 44px;
    font-size: 15px;
    color: #bdbdbd;
    margin: 0 auto 60px;
    text-align: center;
    border: 1px solid #dfdfdf;
    display: block;
    transition: all 0.3s;
    text-decoration: none;
}
.more_btn2:hover{
    color: #fff;
    background: #bdbdbd;
}
a{
  text-decoration: none !important;
}
.template7_inner_container_black{
  background: #fff;
}
.template7_index_waterfall_wrap_black .title{
  color: #bdbdbd !important;
}
</style>
